import { z as zod } from 'zod';

/**
 * Environment-variable schema for the public-ui SPA. `PUBLIC_*` values are baked into the bundle at
 * build time via Vite; this schema validates them at app mount so a CI-side misconfiguration fails
 * at app boot instead of surfacing as an undefined deep inside Accept.js.
 */
const envSchema = zod.object({
  PUBLIC_AUTHORIZENET_SANDBOX: zod.enum(['true', 'false']),
  PUBLIC_AUTHORIZENET_CLIENT_KEY: zod.string().min(1),
  PUBLIC_AUTHORIZENET_API_LOGIN_ID: zod.string().min(1),
  // Base URLs the SPA fetches reference/document content from. SWA route `rewrite` only supports
  // relative paths (per the official docs) — absolute URLs in `rewrite` are silently dropped by
  // the SWA edge. The SPA therefore fetches the storage URL directly. Dev: `/data` + `/documents`
  // (Vite dev middleware in `scripts/vite-dev-reference-data.ts` serves both). Prod: the absolute
  // blob hostnames (`https://<storage>.blob.core.windows.net/{reference-data,documents}`) —
  // requires CORS allowing the SWA origin on the storage account (Phase 4 of PROVISION.md).
  PUBLIC_REFERENCE_DATA_URL: zod.string().min(1),
  PUBLIC_DOCUMENTS_URL: zod.string().min(1),
});

const result = envSchema.safeParse(import.meta.env);
if (!result.success) {
  const missing = result.error.issues.map((i) => `  ${i.path.join('.')}: ${i.message}`).join('\n');
  throw new Error(`Invalid public-ui environment configuration:\n${missing}`);
}

/**
 * Validated browser-exposed environment variables for the public-ui SPA.
 */
export const env = result.data;
